<template>
  <el-table
    :data="tableData"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column prop="area" label="地域" align="center"> </el-table-column>
    <el-table-column prop="provice" label="省" align="center">
    </el-table-column>
    <el-table-column prop="city" label="市" align="center"> </el-table-column>
    <el-table-column prop="payCustomerCount" label="付款人数" align="right" sortable width="160">
    </el-table-column>
    <el-table-column prop="successPayment" label="付款金额" align="right" sortable width="140">
    </el-table-column>
    <el-table-column prop="payAvgRate" label="付款客单价（元）" align="right" width="160">
    </el-table-column>
    <!-- <el-table-column prop="memberCount" label="付款会员数" align="right" sortable width="160">
    </el-table-column> -->
    <el-table-column prop="reBuyCustomerCount" label="复购人数" align="right" sortable width="140">
    </el-table-column>
    <el-table-column prop="reBuyRate" label="复购率" align="right" sortable width="140">
      <template slot-scope="scope"> {{ scope.row.reBuyRate }}% </template>
    </el-table-column>
  </el-table>
</template>

<script>
import Empty from "../components/empty.vue";
export default {
  name: "region_distribution_analysis",
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    reportParams: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    prevReportView() {
      return this.reportParams.reportView || 0;
    },
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if(rowIndex == 0) {
        let spanArr = ['area', 'provice', 'city']
        let isSame = spanArr.every(item => row[item] == '合计')
        if(isSame){
          if(columnIndex === 0){
             return {
               rowspan: 1,
               colspan: spanArr.length
            };
          }
          for(let i = 1; i < spanArr.length; i++){
            if(columnIndex == i){
              return {
                rowspan: 0,
                colspan: 0
               };
            }
          }
        }
        return
      }
      if (this.prevReportView == 1) {
        switch (column.property) {
          case "area":
            return this.getSpan(rowIndex, [
              "area",
            ]);
          case "provice":
            return this.getSpan(rowIndex, [
              "area",
              "provice",
            ]);
          default:
            return;
        }
      }
    },
    getSpan(rowIndex, fields) {
      const data = this.tableData;
      // 判断是否和上一行属于同一组
      if (
        rowIndex > 0 &&
        fields.every((key) => data[rowIndex][key] === data[rowIndex - 1][key])
      ) {
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
      // 计算连续相同的数量
      let rowspan = 1;
      for (let i = rowIndex + 1; i < data.length; i++) {
        if (fields.every((key) => data[rowIndex][key] === data[i][key])) {
          rowspan++;
        } else {
          break;
        }
      }
      return {
        rowspan,
        colspan: 1,
      };
    },
  },
};
</script>
